import { Component, type ReactNode } from "react";
import { trackClientError } from "../lib/analytics.js";

/**
 * フロント例外の計測（client_error イベント）付き ErrorBoundary。
 * PII混入防止のためエラー名のみ送信し、メッセージ本文・スタックは送らない。
 */
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { hasError: boolean }
> {
  state = { hasError: false };

  static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  componentDidCatch(error: Error): void {
    trackClientError(error.name || "Error");
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 48, textAlign: "center", color: "#334155" }}>
          <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>
            画面の表示中にエラーが発生しました
          </div>
          <div style={{ fontSize: 13, color: "#64748b", marginBottom: 16 }}>
            再読み込みしても解消しない場合は管理者にお問い合わせください。
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "8px 20px", borderRadius: 6, border: "1px solid #cbd5e1",
              background: "#0f766e", color: "#fff", cursor: "pointer", fontSize: 13,
            }}
          >
            再読み込み
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
